const maganeTemplates = {
    CHANGE_SUCCESS: 'CHANGE_SUCCESS',
    GET_USERS_EXPIRED: 'GET_USERS_EXPIRED',
    GET_MA_EXPIRED: 'GET_MA_EXPIRED',
    GET_ACTIVATION_EMAIL: 'GET_ACTIVATION_EMAIL',
    MA_SIGNUP_EMAIL: 'MA_SIGNUP_EMAIL',
    GET_DOMAIN: 'GET_DOMAIN'
}

export default maganeTemplates


// WEBPACK FOOTER //
// src/routes/Domain/actions/actionTypes.js